import { Card, Title, Divider, Stack, Box, Image } from "@mantine/core";
import logo from "../../assets/logo-icon.svg";
import { useTranslation } from "react-i18next";

function SponsorsSection({ sponsors, displaySponsors }) {
  const { t } = useTranslation();

  if (!displaySponsors || !sponsors || sponsors.length === 0) {
    return null;
  }

  const groupSponsorsByLevel = (sponsors) => {
    const grouped = sponsors.reduce((acc, sponsor) => {
      const levelKey = sponsor.levelId || "no-level";
      const levelName = sponsor.levelName || "Other";
      const levelOrder = sponsor.levelOrder ?? 999;

      if (!acc[levelKey]) {
        acc[levelKey] = {
          levelName,
          levelOrder,
          sponsors: [],
        };
      }
      acc[levelKey].sponsors.push(sponsor);
      return acc;
    }, {});

    Object.values(grouped).forEach((level) => {
      level.sponsors.sort((a, b) => {
        if (a.order !== b.order) return (a.order ?? 0) - (b.order ?? 0);
        return a.id - b.id;
      });
    });

    return Object.entries(grouped)
      .map(([levelId, data]) => ({
        levelId,
        levelName: data.levelName,
        levelOrder: data.levelOrder,
        sponsors: data.sponsors,
      }))
      .sort((a, b) => a.levelOrder - b.levelOrder);
  };

  const getLogoSize = (levelIndex, totalLevels) => {
    const maxSize = 200;
    const minSize = 100;
    const percentage = 1 - levelIndex / (totalLevels || 1);
    return Math.round(minSize + (maxSize - minSize) * percentage);
  };

  const groupedSponsors = groupSponsorsByLevel(sponsors);

  return (
    <Card shadow="sm" p="lg" radius="md" withBorder mt="lg">
      <Stack gap="xl">
        <Title order={2} ta="center">
          {t("sponsors")}
        </Title>
        <Divider />

        {groupedSponsors.map((level, levelIndex) => {
          const logoSize = getLogoSize(levelIndex, groupedSponsors.length);

          return (
            <Box key={level.levelId}>
              <Title order={3} ta="center" mb="lg" c="dimmed">
                {level.levelName}
              </Title>
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "2rem",
                }}
              >
                {level.sponsors.map((sponsor) => {
                  return (
                    <Box
                      key={sponsor.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "1rem",
                      }}
                    >
                      <Image
                        src={sponsor.logo || logo}
                        alt={sponsor.name}
                        fit="contain"
                        h={logoSize}
                        w={logoSize}
                        styles={{
                          image: {
                            objectFit: "contain",
                          },
                        }}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Card>
  );
}

export default SponsorsSection;
